import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { text, secondary } = theme.palette;

  return {
    dialogPaper: {
      width: 343,
      minHeight: 454,
      borderRadius: 6,
      boxShadow: "0px 0px 12px 0px rgba(0, 0, 0, 0.4)",
      overflowY: "hidden"
    },
    dialogTitle: {
      padding: "27px 24px 0",
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
      "& .MuiTypography-root": {
        lineHeight: "25px"
      }
    },
    dialogContent: {
      paddingBottom: 0,
      overflowY: "hidden"
    },
    dialogContentHeader: {
      fontSize: 16,
      lineHeight: "38px"
    },
    trainerName: {
      fontSize: 17,
      marginTop: 4,
      wordBreak: "break-all"
    },
    stableEntriesInfo: {
      fontSize: 13,
      marginBottom: 16
    },
    dialogActions: {
      display: "flex",
      justifyContent: "space-between",
      padding: "15px 14px 10px 10px"
    },
    backButton: {
      color: text.secondary
    },
    submitButton: {
      color: secondary.dark
    }
  };
});
